// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__U36R3"};